import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: string;
  tenantId: string;
  lastLogin: string | null;
  mfaEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateUserProfileData {
  firstName?: string;
  lastName?: string;
}

export interface UpdatePasswordData {
  currentPassword: string;
  newPassword: string;
}

export const useUserProfile = () => {
  return useQuery<UserProfile>({
    queryKey: ['user-profile'],
    queryFn: async () => {
      return await apiClient.get<UserProfile>('/user/profile');
    }
  });
};

export const useUpdateUserProfile = () => {
  const queryClient = useQueryClient();
  
  return useMutation<UserProfile, Error, UpdateUserProfileData>({
    mutationFn: async (data: UpdateUserProfileData) => {
      return await apiClient.put<UserProfile>('/user/profile', data);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['user-profile'], data);
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
    }
  });
};

export const useUpdatePassword = () => {
  return useMutation<{ message: string }, Error, UpdatePasswordData>({
    mutationFn: async (data: UpdatePasswordData) => {
      return await apiClient.put<{ message: string }>('/user/password', data);
    }
  });
};